export default defineNuxtRouteMiddleware(async (to) => {
  if (true) {
    const session = await useSessionGuard().validateSession();

    if (!session.authenticated) {
      return navigateTo({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }

    if (useUser().getUser?.id) {
      if (to.fullPath.includes('/admin') && !useUser().getUser.is_staff) {
        return navigateTo('/')
      }
    }
  }
});
